import { lazy } from "react";
import type { Value } from "react-phone-number-input";

interface Props {
  phone: string;
  onChange: (value?: Value) => void;
  disabled?: boolean;
}

export const PhoneInput = lazy(async () => {
  const [{ default: ReactPhoneInput }, { cn }] = await Promise.all([import("react-phone-number-input"), import("@components/utils/utils")]);

  // Import CSS
  await import("react-phone-number-input/style.css");

  const PhoneInputImpl = ({ phone, onChange, disabled = false }: Props) => {
    return (
      <ReactPhoneInput
        value={phone}
        defaultCountry="FR"
        onChange={onChange}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&_input]:bg-transparent [&_input]:outline-none",
          disabled ? "text-muted-foreground cursor-not-allowed" : "text-foreground",
        )}
        disabled={disabled}
      />
    );
  };

  return { default: PhoneInputImpl };
});
